import {
  FormErrorMessageProps,
  Textarea as ChakraTextarea,
  TextareaProps as ChakraTextareaProps,
} from '@chakra-ui/react';
import { ComponentStyleConfig } from '@chakra-ui/theme';
import { FormErrorMessage } from 'components/UI/forms';

export type TextareaProps = ChakraTextareaProps & {
  error?: string;
  errorProps?: FormErrorMessageProps;
};

const TextareaStyles: ComponentStyleConfig = {
  baseStyle: {
    height: 'auto',
  },
  variants: {
    filled: {
      borderRadius: 'none',
      border: 'none',
      backgroundColor: 'gray.100',
      _focus: {
        backgroundColor: 'gray.100',
        boxShadow: 'none',
        border: 'none',
      },
    },
  },
  sizes: {
    md: {
      field: {
        px: 3,
        py: 2,
        borderRadius: 3,
      },
    },
  },
};

const Textarea = ({
  errorProps = {},
  error,
  variant = 'filled',
  size = 'md',
  resize = 'none',
  ...props
}: TextareaProps) => (
  <>
    <ChakraTextarea variant={variant} size={size} resize={resize} {...props} />
    <FormErrorMessage {...errorProps}>{error}</FormErrorMessage>
  </>
);

export { Textarea, TextareaStyles };
